import React, { useMemo, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Button, Spinner } from "react-bootstrap";
import { apiBase } from "../../Config";
import useResponsiveFontSize from "./assets/useResponsiveFontSize";
import "./assets/CardSelectionStyle.css";

const useOptions = () => {
  const fontSize = useResponsiveFontSize();
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize,
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: "Source Code Pro, monospace",
          "::placeholder": {
            color: "#aab7c4",
          },
        },
        invalid: {
          color: "#9e2146",
        },
      },
    }),
    [fontSize]
  );

  return options;
};

const StepPayment = ({
  smallMessage,
  userId,
  adminToken,
  updateCardErrorMessage,
  cardErrorMessage,
  gotoNextScreen,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();
  const [isUpdatingCard, setIsUpdatingCard] = useState(false);

  const handleUpdatePayment = async () => {
    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }
    setIsUpdatingCard(true);
    updateCardErrorMessage("");
    const payload = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
    });
    console.log(payload);

    if ("error" in payload) {
      updateCardErrorMessage(payload.error.message);
      setIsUpdatingCard(false);
    } else {
      const cardLast4 = payload.paymentMethod.card.last4;
      const paymentId = payload.paymentMethod.id;
      const cardBrand = payload.paymentMethod.card.brand;

      await fetch(apiBase + "admin/payments/payment_id", {
        method: "PUT",
        body: new URLSearchParams({
          user_id: userId,
          app_token: adminToken,
          payment_id: paymentId,
          card_last4: cardLast4,
          card_brand: cardBrand,
        }),
      });

      // Adding or Updating subscription to the user
      await fetch(apiBase + "admin/payments/update-subscription", {
        method: "PUT",
        body: new URLSearchParams({
          user_id: userId,
          app_token: adminToken,
        }),
      });

      setIsUpdatingCard(false);

      gotoNextScreen();

      // if (response.status === 200) {
      //   //const data = await response.json();

      //   // admin_data.stripe_customer_id = data.stripe_customer_id;
      // } else console.log(response);
    }
  };

  return (
    <div>
      <div style={{ marginTop: "50px" }}>
        <h2 style={{ fontWeight: "100", fontSize: "28px", lineHeight: "1.5em" }}>
          Finally, add a billing method to your account
        </h2>
      </div>

      <div style={{ marginTop: "50px" }}>
        {/* <p style={{ fontSize: "20px" }}>Finally, choose a password for your admin account</p> */}
        {smallMessage !== "" && (
          <div style={{ margin: "5px 0 15px 0" }}>
            <i>{smallMessage}</i>
          </div>
        )}

        {cardErrorMessage !== "" && <div style={{ color: "red", margin: "10px 0 10px 0" }}>{cardErrorMessage}</div>}

        <div>
          <CardElement options={options} />

          <Button variant="primary" style={{ marginTop: "20px" }} onClick={handleUpdatePayment}>
            {isUpdatingCard === true ? (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            ) : (
              "Update Card"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StepPayment;
